export default __webpack_public_path__ + "static/media/success-notification.650bf223.svg";